import React from "react";
import DateHelpers from '../Helper/DateHelpers.js';
import AddTransaction from '../Routes/AddTransaction.js'
import AccountDetails from "./AccountDetails.js";
import ViewTransactionHistory from '../Components/ViewTransactionHistory.js'
import { useNavigate } from "react-router-dom";
import RegistrationInfo from "./RegistrationInfo.js";
import { useState, useEffect } from "react";
import AdminGroupAccountReservationCardList from "./AdminGroupAccountReservationCardList.js";
import '../Styles/AdminGroupAccountCamperJoined.scss';
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import RegistrationDetails from "./RegistrationDetails.js";



function AdminGroupAccountCamperJoined({camperJoined}) {
   return(
      <div className="AdminGroupAccountCamperJoinedContainer">
         <div className="AdminGroupAccountCamperJoinedContent">
            <div className="AdminGroupAccountCamperJoinedItem">
               {camperJoined.first_name + " " + camperJoined.last_name}
            </div>
            <div className="AdminGroupAccountCamperJoinedItem">
               {camperJoined.gender}
            </div>
            <div className="AdminGroupAccountCamperJoinedItem">
               {camperJoined.role}
            </div>
         </div>
      </div>
   )
}
export default AdminGroupAccountCamperJoined